<template>
    <div class="preview">
        <headers :title='title'></headers>
        <template v-if="loadingS">
            <h3 class="sum">共{{askLength}}题
                <span v-if="user_id">
                    （答对
                    <span class="t">{{t_right}}</span>题、答错
                    <span class="t">{{t_wrong}}</span>题）
                </span>
            </h3>
            <div class="content ensync_work_cont">
                <div class="topic"
                     v-for="(topic,tIndex) in list">
                    <!-- 一题多问的大题干 -->
                    <div class="title"
                         v-if="topic.asks.length>1">
                        <p v-html="topic.subject.title"
                           v-if="topic.subject.title"></p>
                        <p :class="{'topic-con':topic.subject.title}"
                           v-html="$options.filters.strReplace(topic.subject.content,'\#\#','或')"
                           v-if="topic.subject.content"></p>
                    </div>

                    <!-- 一题多问的大题题干图片 -->
                    <template v-if="topic.asks.length>1&&topic.subject&&topic.subject.images">
                        <div class="cont_img"
                             v-for=" (img) in topic.subject.images ">
                            <img :src="img"
                                 alt="" />
                        </div>
                    </template>
                    <div v-if="topic.listen_audio">
                        <audio-component :ask="topic"
                                         :sid="sid"></audio-component>
                    </div>
                    <!-- 分一题一问和一题多问主要是为了添加错号对号 -->
                    <template v-for="(ask,askInd) in topic.asks">
                        <div class="ask">
                            <!-- 一题一问的题干 -->
                            <div class="title"
                                 v-if="topic.asks.length===1">
                                <p v-html="topic.subject.title"
                                   v-if="topic.subject.title"></p>
                                <p :class="{'topic-con':topic.subject.title}"
                                   v-html="$options.filters.strReplace(topic.subject.content,'\#\#','或')"
                                   v-if="topic.subject.content"></p>
                            </div>
                            <!-- 一题一问的题干图片 -->
                            <template v-if="topic.asks.length===1">
                                <div class="cont_img"
                                     v-for=" (img) in topic.subject.images ">
                                    <img :src="img"
                                         alt="" />
                                </div>
                            </template>
                            <!-- 如果是听力，加上听力条 -->
                            <div class="audio"
                                 v-if="ask.listen_audio">
                                <audio-component :ask='ask'
                                                 :sid="sid"></audio-component>
                            </div>

                            <!-- 选择题、听力题、完形填空、阅读理解 -->
                            <div v-if="topic.type===1||topic.type===3||topic.type===4||topic.type===5||topic.type===6||topic.type===7||topic.type===8||(sid==92&&topic.type===1)||(sid==92&&topic.type===2)||(sid==92&&topic.type===4)">
                                <choose-component :myColor='true'
                                                  :checked="user_id?true:false"
                                                  :ask="ask"
                                                  :type="topic.type"
                                                  :length="topic.asks.length"
                                                  :index="askInd"
                                                  :sid="sid"
                                                  :isAudio="ask.listen_audio"
                                                  :mystatus="user_id?1:''"></choose-component>
                            </div>
                            <!-- 填空题 -->
                            <div v-else-if="topic.type === 9">
                                <fill-component :myColor='true'
                                                :ask="ask"></fill-component>
                            </div>
                            <!-- 连线题 -->
                            <div v-else-if="topic.type === 2">
                                <line-component :ask="ask"
                                                :onlyshow="true"
                                                :myColor='user_id?true:false'
                                                :sheet="user_id?ask.stu_answer:ask.answer"></line-component>
                            </div>
                            <!-- 连词成句、连句成段 -->
                            <div v-else-if="topic.type===10||topic.type===11">
                                <make-component :myColor='true'
                                                :ask="ask"
                                                :user_id='user_id'
                                                :is_answer="true"
                                                :type="topic.type"></make-component>
                            </div>
                            <template v-if="user_id">
                                <template v-if="topic.type ===1||topic.type===3||topic.type===4||topic.type===5||topic.type===6||topic.type===7||topic.type===8||(sid==92&&topic.type===1)||(sid==92&&topic.type===2)||(sid==92&&topic.type===4)">
                                    <p class="user_answer">正确答案：{{ask.right_option.option||ask.right_option}}</p>
                                    <i class="test_right"
                                       v-if="ask.stu_result"></i>
                                    <i class="test_wrong"
                                       v-else></i>
                                </template>
                                <template v-else-if="topic.type===9 || topic.type===7">
                                    <!-- {{ask.stu_answer.split('|').join(',')}} -->
                                    <!-- <p class="user_answer">正确答案：</p> -->
                                    <p class="user_answer"
                                       v-if='topic.type===9'>正确答案：
                                        <template v-for='a in ask.answer'>
                                            <span class="a">{{a}}</span>
                                        </template>
                                    </p>
                                    <i class="test_right"
                                       v-if="ask.stu_result"></i>
                                    <i class="test_wrong"
                                       v-else></i>
                                </template>
                                <template v-else-if="topic.type === 2">
                                    <p class="user_answer">正确答案：</p>
                                    <line-component :ask="ask"
                                                    :onlyshow="true"
                                                    :tag="'s'"
                                                    :sheet="ask.answer"></line-component>
                                    <i class="test_right"
                                       v-if="ask.stu_result"></i>
                                    <i class="test_wrong"
                                       v-else></i>
                                </template>
                                <template v-else-if="topic.type === 10||topic.type === 11">
                                    <p class="user_answer">正确答案：</p>
                                    <make-component :ask="ask"
                                                    :is_answer="true"
                                                    :type="topic.type"></make-component>
                                    <i class="test_right"
                                       v-if="ask.stu_result"></i>
                                    <i class="test_wrong"
                                       v-else></i>
                                </template>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            <div class="bottom_btn"
                 v-if="user_id">
                <div @click="reward">奖励和评语</div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';
import headers from 'COMPONENTS/base/header.vue';
import chooseComponent from 'VIEWS/english/module/result_choose.vue';   //选择题
import fillComponent from 'VIEWS/english/module/result_fill.vue';   //填空题
import lineComponent from 'VIEWS/english/module/line.vue';   //连线题
import makeComponent from 'VIEWS/english/module/result_make.vue';   //连词成句、连句成段题
import audioComponent from 'VIEWS/english/module/result_audio.vue';  //听力进度条
// import audioComponent from 'SRC/components/english/module/tea/audio.vue';  //听力进度条

export default {
    data () {
        return {
            title: '作业预览',
            sid: this.$route.params.sid,
            message_id: this.$route.params.message_id,
            task_type: this.$route.params.task_type,
            user_id: this.$route.query.user_id,//学生ID
            name: this.$route.query.name,//学生ID
            score: this.$route.query.score,
            qids: [],
            list: [],
            askLength: 0,//小题数量
            loadingS: false,
            t_right: 0,
            t_wrong: 0,
        }
    },
    components: {
        loadingS, headers, chooseComponent, fillComponent, lineComponent, makeComponent, audioComponent
    },
    methods: {
        reward () {
            this.$router.push("/tea/perreward/" + this.sid + "/" + this.message_id + "/" + this.user_id + "?score=" + this.score + "&name=" + this.name);
        }
    },
    created () {
        if (this.user_id) {
            this.title = this.name + '（' + this.score + '分）';
            this.$http.post(API_URL_TASK_API + '/english/check/personal', {
                message_id: this.message_id,
                task_type: this.task_type,
                sid: this.sid,
                user_id: this.user_id
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.list = res.data.sync_list;
                    this.list.forEach(item => {
                        this.askLength += item.asks.length;
                        item.asks.forEach((m) => {
                            if (m.stu_result) {
                                this.t_right++
                            } else {
                                this.t_wrong++
                            }
                        })
                    });
                    this.loadingS = true;
                }
            })
        } else {
            this.$http.post(API_URL_TASK_API + '/english/task/sync', {
                message_id: this.message_id,
                sid: this.sid,
                user_type: 3
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.list = res.data;
                    this.list.forEach(item => {
                        this.askLength += item.asks.length;
                        item.asks.forEach((m) => {
                            if (m.stu_result) {
                                this.t_right++
                            } else {
                                this.t_wrong++
                            }
                        })
                    });
                    this.loadingS = true;
                }
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.preview {
    min-height: 100vh;
    .sum {
        font-weight: bold;
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        color: #333;
        background: #fff;
        .t {
            color: #ff6600;
        }
    }
    .content {
        font-family: Monospace;
        margin-bottom: 24px / $ppr;
        font-size: 30px / $ppr;
        padding-bottom: 96px / $ppr;
        color: #333;
        .topic {
            margin-top: 24px / $ppr;
            background: #fff;
            .title {
                p {
                    padding: 34px / $ppr 24px / $ppr;
                    &.topic-con {
                        border-top: 1px / $ppr solid #e8e8e8;
                    }
                }
            }
            .ask {
                position: relative;
                .user_answer {
                    padding: 34px / $ppr 24px / $ppr;
                    border-top: 1px / $ppr solid #e8e8e8;
                    color: #999;
                    .a {
                        display: inline-block;
                        margin-left: 10px / $ppr;
                    }
                }
                .audio {
                    position: relative;
                    // padding: 0 24px/$ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    background-color: #f6f6f6;
                    box-sizing: border-box;
                }
                .test_right {
                    position: absolute;
                    right: 24px / $ppr;
                    top: 34px / $ppr;
                    display: block;
                    width: 40px / $ppr;
                    height: 36px / $ppr;
                    background: url("./img/test_right.png") no-repeat;
                    background-size: 100% 100%;
                }
                .test_wrong {
                    position: absolute;
                    right: 24px / $ppr;
                    top: 34px / $ppr;
                    display: block;
                    width: 40px / $ppr;
                    height: 36px / $ppr;
                    background: url("./img/test_wrong.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .bottom_btn {
        position: fixed;
        left: 0;
        bottom: 0;
        height: 96px / $ppr;
        width: 100%;
        z-index: 8;
        div {
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            background: #5e89ef;
            text-align: center;
            font-size: 30px / $ppr;
            color: #fff;
            line-height: 96px / $ppr;
        }
    }
}
</style>
